import { Divider } from "@/components/shared/divider";
import { FormControlError } from "@/components/shared/form-control-error";
import { InputFormControl } from "@/components/shared/input-form-control";
import { Typography } from "@/components/shared/typography";
import { VisitRatingInput } from "@/components/shared/visits/visit-rate/visit-rating-input";
import { Textarea, View } from "@/components/ui";
import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";

export function RateVisitInput({
  readonly,
  control,
}: {
  readonly: boolean;
  control: Control<{
    rating: number;
    comment: string;
  }>;
}) {
  const ratingState = control.getFieldState("rating");

  return (
    <>
      <View className="flex flex-col gap-6 py-6">
        <Typography variant="label-sm">How was your service?</Typography>
        <Controller
          name="rating"
          control={control}
          render={({ field }) => (
            <VisitRatingInput
              rating={field.value}
              onChange={field.onChange}
              disabled={field.disabled ?? readonly}
            />
          )}
        />
        {ratingState.error?.message && (
          <FormControlError error={ratingState.error.message} />
        )}
      </View>
      <Divider className="h-1 bg-background-intermediate" />
      <View className="flex flex-col gap-1 py-6">
        <Typography variant="label-sm">We’d love your feedback</Typography>
        <InputFormControl
          disabled={readonly}
          name="comment"
          className="mt-3"
          control={control}
          component={Textarea}
          componentProps={{
            placeholder: "Compliment your cleaner or leave us feedback.",
            readOnly: readonly,
          }}
        />
      </View>
    </>
  );
}
